import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RepaymentList2UI from './RepaymentList2UI.js'

class RepaymentList2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      response: null,
      updateRemarksMode: false,
      updateDefaultsMode: false,
      updateInterestMode: false,
      updatePrincipalMode: false,
      addPaymentMode: false,
      addIntPriMode: false,
      selectedRepayment: null,
      selectedCharge: null,
      selectedChargeType: null,
      //
      emiPaymentSubmitted: false,
      emiPaymentErrorList: null,
      selectedScheduledDate: null,
      //
      penaltySubmitted: false,
      paymentSubmitted: false,
      addRowMode: false,
      details: true,
      //
      downloadPenalChargeSubmitted: false
    }
  }

  render() {
    return (
      <RepaymentList2UI
        context={this.props.context}
        errorList={this.state.errorList}
        response={this.state.response}
        repaymentList={this.props.repaymentList}
        chargeAmountsList={this.props.chargeAmountsList}
        totals={this.props.totals}
        onRefreshClick={this.props.onRefreshClick}
        account={this.props.account}
        loan={this.props.loan}
        //
        updateRemarksMode={this.state.updateRemarksMode}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        onCancelRemarksClick={() => { this.setState({ updateRemarksMode: false }) }}
        selectedRepayment={this.state.selectedRepayment}
        //
        addPaymentMode={this.state.addPaymentMode}
        onAddPaymentClick={this.onAddPaymentClick}
        onCancelPaymentClick={() => { this.setState({ addPaymentMode: false }) }}
        selectedCharge={this.state.selectedCharge}
        //
        addIntPriMode={this.state.addIntPriMode}
        onAddIntPriClick={this.onAddIntPriClick}
        onCancelIntPriClick={() => { this.setState({ addIntPriMode: false }) }}
        selectedChargeType={this.state.selectedChargeType}
        //
        updateOpExpensesMode={this.state.updateOpExpensesMode}
        onUpdateOpExpensesClick={this.onUpdateOpExpensesClick}
        onCancelOpExpensesClick={() => { this.setState({ updateOpExpensesMode: false }) }}
        //
        addChargeAmountMode={this.state.addChargeAmountMode}
        onAddChargeAmountClick={this.onAddChargeAmountClick}
        onCancelChargeAmountClick={() => { this.setState({ addChargeAmountMode: false }) }}
        //
        updateDefaultsMode={this.state.updateDefaultsMode}
        onUpdateDefaultsClick={this.onUpdateDefaultsClick}
        onCancelDefaultsClick={() => { this.setState({ updateDefaultsMode: false }) }}
        //
        updateInterestMode={this.state.updateInterestMode}
        onUpdateInterestClick={this.onUpdateInterestClick}
        onCancelInterestClick={() => { this.setState({ updateInterestMode: false }) }}
        //
        updatePrincipalMode={this.state.updatePrincipalMode}
        onUpdatePrincipalClick={this.onUpdatePrincipalClick}
        onCancelPrincipalClick={() => { this.setState({ updatePrincipalMode: false }) }}
        //
        downloadPenalChargeSubmitted={this.state.downloadPenalChargeSubmitted}
        onDownloadPenalChargeClick={this.onDownloadPenalChargeClick}
        //
        updateBalanceMode={this.state.updateBalanceMode}
        onUpdateBalanceClick={this.onUpdateBalanceClick}
        onCancelBalanceClick={() => { this.setState({ updateBalanceMode: false }) }}
        //
        onEmiPaymentClick={this.onEmiPaymentClick}
        emiPaymentSubmitted={this.state.emiPaymentSubmitted}
        emiPaymentErrorList={this.state.emiPaymentErrorList}
        selectedScheduledDate={this.state.selectedScheduledDate}
        //
        onPenaltyClick={this.onPenaltyClick}
        penaltySubmitted={this.state.penaltySubmitted}
        onPenaltyCancelClick={() => { this.setState({ penaltySubmitted: false }) }}
        //
        paymentSubmitted={this.state.paymentSubmitted}
        onPayClick={() => { this.setState({ paymentSubmitted: true }) }}
        onPayCancelClick={() => { this.setState({ paymentSubmitted: false }) }}
        //
        addRowMode={this.state.addRowMode}
        onAddRowClick={() => { this.setState({ addRowMode: true }) }}
        onAddRowCancel={() => { this.setState({ addRowMode: false }) }}
        //
        onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
        details={this.state.details}
      />
    )
  }

  componentDidMount() {
  }

  onEmiPaymentClick = (event) => {
    let context = this.props.context
    let scheduledDate = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      emiPaymentErrorList: [],
      emiPaymentSubmitted: true,
      selectedScheduledDate: scheduledDate
    })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${scheduledDate}/initialize`,
      this.onEmiPaymentClickCallback, {})
  }

  onEmiPaymentClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      emiPaymentErrorList: errorList,
      emiPaymentSubmitted: false,
      selectedScheduledDate: null
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onPenaltyClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      penaltySubmitted: true,
      selectedScheduledDate: scheduledDate
    })
  }

  onUpdateRemarksClick = (event) => {
    let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
    let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
    this.setState({ updateRemarksMode: true, selectedRepayment: selectedRepayment })
  }

  onAddPaymentClick = (event) => {
    //let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date');
    let scheduledDate = Number(event.currentTarget.getAttribute('data-scheduled-date')); // Convert to number if it's string

    //let dateCreated = event.currentTarget.getAttribute('data-created-date');
    let dateCreated = Number(event.currentTarget.getAttribute('data-created-date')); // Convert to number if it's string

    let chargeType = event.currentTarget.getAttribute('data-charge-type');

    // Use filter to find matching repayments and take the first one
    //let selectedRepayments = this.props.repaymentList.filter(r => r.scheduledDate === scheduledDate);
    let selectedRepayments = this.props.repaymentList.filter(r => {
      return new Date(r.scheduledDate).getTime() === scheduledDate; // Ensure both are compared as timestamps
    });

    let selectedRepayment = selectedRepayments[0];

    if (selectedRepayment) {
      // Filter charges within the selectedRepayment
      let selectedCharges = selectedRepayment.chargesAmountsList.filter(charge => {
        return new Date(charge.dateCreated).getTime() === dateCreated && charge.chargeType === chargeType;
      });

      // Check if selectedCharges is not empty before accessing the first element
      let selectedCharge = selectedCharges.length > 0 ? selectedCharges[0] : null; // Take the first match in selectedCharges

      this.setState({
        addPaymentMode: true,
        selectedRepayment: selectedRepayment,
        selectedCharge: selectedCharge
      });
    } else {
      console.error("No matching repayment found for scheduled date:", scheduledDate);
    }
  }

  onAddIntPriClick = (event) => {
    console.log("clicked")
    let scheduledDate = Number(event.currentTarget.getAttribute('data-scheduled-date'));
    let chargeType = event.currentTarget.getAttribute('data-charge-type');

    let selectedRepayments = this.props.repaymentList.filter(r => {
      return new Date(r.scheduledDate).getTime() === scheduledDate;
    });

    let selectedRepayment = selectedRepayments[0];
    console.log(scheduledDate, chargeType, selectedRepayments)
    if (selectedRepayment) {
      // Only need one charge for this use case
      let selectedCharge = selectedRepayment.chargesAmountsList.find(charge => {
        return charge.chargeType === chargeType;
      });
      const isChargeSelected = selectedCharge !== undefined;

      if (isChargeSelected) {
        console.log("Selected Charge:", selectedCharge);
        this.setState({
          addIntPriMode: true,
          selectedChargeType: selectedCharge.chargeType,
          selectedRepayment: selectedRepayment
        });
      } else {
        // Handle the case where selectedCharge is undefined
        console.log("No charge found for the selected type.");
        this.setState({
          addIntPriMode: true,
          selectedChargeType: chargeType, 
          selectedRepayment: selectedRepayment
        });
      }
    }
  }

    onUpdateOpExpensesClick = (event) => {
      let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
      this.setState({ updateOpExpensesMode: true, selectedRepayment: selectedRepayment })
    }

    onAddChargeAmountClick = (event) => {
      let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
      console.log(selectedRepayment)
      this.setState({ addChargeAmountMode: true, selectedRepayment: selectedRepayment })
    }

    onUpdateDefaultsClick = (event) => {
      let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
      this.setState({ updateDefaultsMode: true, selectedRepayment: selectedRepayment })
    }

    onUpdateInterestClick = (event) => {
      let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
      this.setState({ updateInterestMode: true, selectedRepayment: selectedRepayment })
    }

    onUpdatePrincipalClick = (event) => {
      let scheduledDate = event.currentTarget.getAttribute('data-scheduled-date')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDate == scheduledDate)[0]
      this.setState({ updatePrincipalMode: true, selectedRepayment: selectedRepayment })
    }

    onUpdateBalanceClick = (event) => {
      let scheduledDateISO = event.currentTarget.getAttribute('data-scheduled-dateISO')
      let selectedRepayment = this.props.repaymentList.filter(r => r.scheduledDateISO == scheduledDateISO)[0]
      this.setState({ updateBalanceMode: true, selectedRepayment: selectedRepayment })
    }

    onDownloadPenalChargeClick = (event) => {
      let scheduledDateISO = event.currentTarget.getAttribute('data-scheduled-dateISO')
      this.setState({
        downloadErrorList: null,
        downloadPenalChargeSubmitted: true
      })
      RestApiUtils.get(this.props.context,
        `/api/su/loans/${this.props.loan.loanId}/scheduledDates/${scheduledDateISO}/penalCharges/invoice/fileDownloadSignedUrl`,
        this.onDownloadPenalChargeClickCallback, null, null
      )
    }

    onDownloadPenalChargeClickCallback = (response) => {
      this.setState({
        downloadErrorList: response.errorList,
        downloadPenalChargeSubmitted: false
      })

      if (response.errorList.length === 0) {
        const link = document.createElement('a')
        link.href = response.signedUrl.signedUrl
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

export default RepaymentList2SF
